export const formatDouble = (value: number, digit = 0) => {
  if (value) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    });
  }

  return '0.00';
};
